import { render, staticRenderFns } from "./BulkDeactivateBrandPopup.vue?vue&type=template&id=2c4f6e58&scoped=true&"
import script from "./BulkDeactivateBrandPopup.vue?vue&type=script&lang=ts&"
export * from "./BulkDeactivateBrandPopup.vue?vue&type=script&lang=ts&"
import style0 from "./BulkDeactivateBrandPopup.vue?vue&type=style&index=0&id=2c4f6e58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4f6e58",
  null
  
)

export default component.exports